// @flow
import * as React from "react";
import Utilities from "../../utils/Utilities";
import { Menu, MenuDivider, MenuItem, Popover, PopoverInteractionKind, Position, AnchorButton } from "@blueprintjs/core";
import Feedback360MainIcon from '../../assets/Feedback360MainIcon.svg';
import FeedbackSettingsIcon from '../../assets/FeedbackSettingsIcon.svg';
import AddUser from '../../assets/AddUser.svg';

export default ({ controller, action, userIsAccountOwner, account, isManager }) => {
  return (
    <Popover
      portalContainer={document.body}
      position={Position.RIGHT}
      boundary="viewport"
      interactionKind={PopoverInteractionKind.HOVER}
      popoverClassName="sidebar-submenu-popover"
      content={
        <Menu className="sidebar-submenu-menu">
          <li className="bp3-menu-header">
            <h6 className="bp3-heading">360 Feedback Settings</h6>
          </li>
          <MenuDivider />

          <MenuItem
            text="Feedback Settings"
            icon={<img src={FeedbackSettingsIcon} alt="Feedback Settings Icon" className="sidebar-custom-icon" />}
            onClick={() => Utilities.navigate("/360_feedback/settings")}
            href="/360_feedback/settings"
          />
          
          <MenuItem
            text="Assign Employees"
            icon={<img src={AddUser} alt="Assign Employees Icon" className="sidebar-custom-icon" />}
            href="/360_feedback/settings/assign-employees"
            onClick={() => Utilities.navigate("/360_feedback/settings/assign-employees")}
          />
        </Menu>
      }
    >
      <AnchorButton
        className="bp3-minimal bp3-sidebar-button"
        active={
          action === '360_feedback_settings' ||
          action === 'template_builder' ||
          action === 'assign_employees'
        }
        text="360 Feedback"
        href="/360_feedback/settings"
        onClick={() => Utilities.navigate('/360_feedback/settings')}
        icon={<img src={Feedback360MainIcon} alt="360 Feedback Settings Icon" className="sidebar-custom-icon" />}
        rightIcon="chevron-right"
      />
    </Popover>
  );
};
